import { AddTag } from '../../molecules/tags/AddTag';
import { Tag } from './Tag';

export interface TagType {
  loading?: boolean;
  value: string;
}

export interface TagsProps {
  onAdd?: (tag: TagType) => void;
  onRemove?: (tag: TagType) => void;
  onClick?: (tag: TagType) => void;
  tags: TagType[];
}

export const Tags = ({ onAdd, onRemove, tags, onClick, ...props }: TagsProps) => (
  <div {...props}>
    {tags.map((tag, index) => (
      <Tag key={index} loading={tag.loading} onRemove={onRemove} onClick={onClick} value={tag.value} />
    ))}
    {onAdd && <AddTag onAdd={onAdd} />}
  </div>
);
